export function AddDatesWithFileName(params: any) {
  if (typeof params.dates === "object" && !Array.isArray(params.dates)) {
    const { dates, fileName } = params;
    const startDate = new Date(dates.startDate).toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
    const endDate = new Date(dates.endDate).toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
    return `${fileName} ${startDate} to ${endDate}`;
  } else if (Array.isArray(params.dates)) {
    const { dates, fileName } = params;
    let datesLabel = [];
    for (let i = 0; i < dates.length; i++) {
      const element = dates[i].label;
      datesLabel.push(element);
    }
    return `${fileName} ${datesLabel.join(" , ")}`;
  }
}
